global.appmap = require('@/appmap/map.json')
global.appmap_auto = require('@/appmap/automap.json')


try {
  var meta_functions = require("@/lib/meta_functions.js").default;
} catch (err) {
  try {
    var meta_functions = require("@/framework/lib/meta_functions.js").default;
  } catch (err) {}
}


 

try {
  var functions = require("@/lib/functions.js").default;
} catch (err) {
  try {
    var functions = require("@/framework/lib/functions.js").default;
  } catch (err) {}
}


import _ from 'lodash'

global.fn = {}


_.assignIn(global.fn, meta_functions);
_.assignIn(global.fn, functions);

//carregar fns auto
for(let nf of global.reqClass.libauto_client){    
    global.reqClass.requirecmpmix(`@/lib/auto/${nf}.js`)().then(fns => {
        _.assignIn(global.fn, fns);
    })
    
}


global.dbdef = {}
//carregar fns auto
for(let dbdef of global.appmap_auto.dbdefs_active){

    const dobj = require(`@/lib/dbdef/${dbdef}.json`)
    global.dbdef[dbdef]=dobj
}

